import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { HeaderNavigation } from '@/components/HeaderNavigation'
import { ApyInfo } from '@/components/ApyInfo'
import { coinsPotBg } from '@/assets/images'
import useOffsets from '@/hooks/useOffsets'

export default function SavingsPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const offsets = useOffsets()

  // Mock APY - in real app will come from API
  const mockAPY = 5.5

  const handleStartSaving = () => {
    navigate('/savings/select')
  }

  return (
    <BaseView
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundImage: `url(${coinsPotBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        paddingTop: `${offsets.top}px`, // Apply base padding to container
      }}
    >
      {/* Standard Header Navigation */}
      <HeaderNavigation
        // title={t('savings')}
        onBackPress={() => navigate(-1)}
        isFixed={true}
        showBackground={false}
        rightIcon={
          <ApyInfo apyPercentage={mockAPY} isFromColorfulScreen={true} />
        }
      />

      {/* Content */}
      <BaseView
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          paddingTop: `${offsets.top}px`, // Standard padding under header
          paddingLeft: '16px', // Base left padding
          paddingRight: '16px', // Base right padding
          paddingBottom: `${offsets.bottom}px`, // Base bottom padding
          textAlign: 'center',
        }}
      >
        <BaseView gap={16} style={{ marginBottom: '32px' }}>
          {/* Main Title */}
          <BaseText
            fontSize={32}
            fontFamily="bold"
            style={{
              color: 'white',
              textAlign: 'center',
              lineHeight: '1.2',
              margin: '0 auto',
            }}
          >
            {t('translation:earn')} {mockAPY}%{' '}
            {t('translation:startSaving.title')}
          </BaseText>

          {/* Description */}
          <BaseText
            fontSize={16}
            fontFamily="medium"
            style={{
              color: 'rgba(255, 255, 255, 0.8)',
              textAlign: 'center',
              lineHeight: '1.2',
              paddingLeft: '16px',
              paddingRight: '16px',
              margin: '0 auto',
            }}
          >
            {t('translation:startSaving.description')}
          </BaseText>
        </BaseView>

        {/* Start Saving Button */}
        <button
          onClick={handleStartSaving}
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)', // Semi-transparent white as in RN
            color: '#FFFFFF', // White text as in RN
            border: 'none',
            borderRadius: '16px',
            padding: '16px 32px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            width: '100%',
            margin: '0 auto',
            transition: 'all 0.2s ease',
          }}
        >
          {t('translation:startSaving.buttonText')}
        </button>
      </BaseView>
    </BaseView>
  )
}
